// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"05ce3f27","189":"f38502cf","214":"d7d6e95a","226":"cb2f14ed","448":"6281fcff","453":"8ba8473b","496":"4758e35d","499":"44ccab75","705":"547e6725","732":"2959246f","765":"cc736cf2","795":"05cb611c","801":"fc5729f6","922":"21eb1942","936":"4835bf21"}[chunkId] + ".chunk.js";
};